// src/pages/Gallery.js
import React from 'react';
import '../App.css';

/* import images you want in gallery */
import Team1 from '../images/Team1.jpg';
import Team2 from '../images/Team2.jpg';
import Team3 from '../images/Team3.jpg';
import Team4 from '../images/Team4.jpg';
import Team5 from '../images/Team5.jpg';
import Team6 from '../images/Team6.jpg';
import Celebrate1 from '../images/Celebrate1.jpg';
import Celebrate2 from '../images/Celebrate2.jpg';
import Celebrate3 from '../images/Celebrate3.jpg';
import Celebrate4 from '../images/Celebrate4.jpg';
import Celebrate5 from '../images/Celebrate5.jpg';
import Coaching from '../images/Coaching.jpg';
import Culture from '../images/Culture.jpg';
import Fans1 from '../images/Fans1.jpg';
import Fans2 from '../images/Fans2.jpg';

const PHOTOS = [
  Team1, Team2, Team3, Team4, Team5, Team6,
  Celebrate1, Celebrate2, Celebrate3, Celebrate4, Celebrate5,
  Coaching, Culture, Fans1, Fans2
];

function Gallery() {
  return (
    <div className="page gallery-page">
      <h2>Gallery</h2>
      <div className="gallery-grid">
        {PHOTOS.map((p, i) => (
          <div className="gallery-item" key={i}>
            <img src={p} alt={`Gallery ${i+1}`} className="gallery-photo" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;

